import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "../button";
import { InputField, TextAreaField } from "../input";
import axios from "axios";

function ContactForm() {
  const [formdata, setformdata] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    iconColor: "white",
    customClass: {
      popup: "colored-toast",
      progressBar: "timerProgressBar",
    },
    showCloseButton: true,
    showConfirmButton: false,
    timer: 2000,
  });

  const sendmailHandler = async (data) => {
    if (submitting) return;
    setSubmitting(true);

    try {
      await axios.post(
        "https://mailer.maverickz.online/",
        {
          ...data,
          token: "MzIJQd2uIDulwUXkpkq9rVnUhhuEkPAwIAKvPZMnZFi0ib9a9V3MyhWTKh3o",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      Toast.fire({
        icon: "success",
        title: "Your Request Sent..!",
      });

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: "Internal server Error...!",
      });

      setTimeout(() => {
        navigate("/");
      }, 2000);
    }
  };

  return (
    <div className="relative w-full h-full">
      {/* Overlay Loader */}
      {submitting && (
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 z-20 flex items-center justify-center">
          <div className="loader"></div>
        </div>
      )}

      <form
        className={`relative z-10 ${submitting ? "pointer-events-none opacity-50" : ""}`}
        onSubmit={(e) => {
          e.preventDefault();
          sendmailHandler(formdata);
        }}
      >
        <InputField
          type="text"
          label="Full Name"
          name="name"
          setvalue={setformdata}
          validate={true}
          disabled={submitting}
        />
        <InputField
          type="number"
          label="Mobile Number"
          name="mobile"
          setvalue={setformdata}
          validate={true}
          disabled={submitting}
        />
        <InputField
          type="email"
          label="Email address"
          name="email"
          setvalue={setformdata}
          validate={true}
          disabled={submitting}
        />
        <InputField
          type="text"
          label="Company Name (Optional)"
          name="company"
          setvalue={setformdata}
          validate={false}
          disabled={submitting}
        />
        <TextAreaField
          label="Message"
          name="message"
          setvalue={setformdata}
          validate={true}
          disabled={submitting}
        />

        <div className="mt-10">
          <Button
            type="submit"
            label={submitting ? "Sending..." : "Submit"}
            disabled={submitting}
          />
        </div>
      </form>

      <div className="w-full h-auto mt-[5%] hidden max-xs:block">
        <p className="primary-heading">+91 9496128372</p>
      </div>

      {/* Spinner CSS */}
      <style>{`
        .loader {
          border: 6px solid #f3f3f3;
          border-top: 6px solid #3498db;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0%   { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default ContactForm;
